/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateRuleSetIdDto
 */
export interface UpdateRuleSetIdDto {
    /**
     * 
     * @type {string}
     * @memberof UpdateRuleSetIdDto
     */
    ruleSetId?: string;
}

/**
 * Check if a given object implements the UpdateRuleSetIdDto interface.
 */
export function instanceOfUpdateRuleSetIdDto(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateRuleSetIdDtoFromJSON(json: any): UpdateRuleSetIdDto {
    return UpdateRuleSetIdDtoFromJSONTyped(json, false);
}

export function UpdateRuleSetIdDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateRuleSetIdDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'ruleSetId': !exists(json, 'ruleSetId') ? undefined : json['ruleSetId'],
    };
}

export function UpdateRuleSetIdDtoToJSON(value?: UpdateRuleSetIdDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'ruleSetId': value.ruleSetId,
    };
}

